export const RELEASE_AI_WORKLOAD = `
  mutation ReleaseAIWorkload($workloadId: ID!) {
    releaseAIWorkload(workloadId: $workloadId) {
      workloadId
      workloadType
      iamRoleArn
      aiComponents
    }
  }
`
